import { Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { BaseStationInspectionDto } from "@/dto/inspection/BaseStationInspectionDto.ts";
import { InspectionSlowStationDto } from "@/dto/inspection/slow/InspectionSlowStationDto.ts";
import { InspectionSlowChargerDto } from "@/dto/inspection/slow/InspectionSlowChargerDto.ts";

/**
 * 완속 충전소 보고서 작성 - req
 */
export class SlowInspectionReqDto extends BaseStationInspectionDto {
    @ValidateNested()
    @Type(() => InspectionSlowStationDto)
    inspectionSlowStationDto: InspectionSlowStationDto;

    @ValidateNested({ each: true })
    @Type(() => InspectionSlowChargerDto)
    inspectionSlowChargerList: InspectionSlowChargerDto[];

    constructor() {
        super();
        this.inspectionSlowStationDto = new InspectionSlowStationDto();
        this.inspectionSlowChargerList = [new InspectionSlowChargerDto()];
    }
}
